import useOnboardingFieldConfiguration from './useOnboardingFieldConfiguration';

const useIndustryFieldConfiguration = () =>
  useOnboardingFieldConfiguration('industry');

export default useIndustryFieldConfiguration;
